export const ADD_CUSTOM_PICTURES_ORDER = 'CART_ADD_CUSTOM_PICTURES_ORDER';
export const ADD_PROVIDER_PICTURES = 'CART_ADD_PROVIDER_PICTURES';
export const DELETE_ALL_CUSTOM_PICTURE = 'CART_DELETE_ALL_CUSTOM_PICTURE';
export const DELETE_CUSTOM_PICTURE = 'CART_DELETE_CUSTOM_PICTURE';
export const SET_ALL_CART = 'CART_SET_ALL_CART';
export const TOGGLE_PICTURE_ACTIVATED = 'CART_TOGGLE_PICTURE_ACTIVATED';
export const TOGGLE_PICTURE_SELECT_ALL = 'CART_TOGGLE_PICTURE_SELECT_ALL';
export const TOGGLE_PICTURE_UNSELECT_ALL = 'CART_TOGGLE_PICTURE_UNSELECT_ALL';
export const UPDATE_PICTURE_ORDER = 'CART_UPDATE_PICTURE_ORDER';
export const CART_UPDATE_VARIANTE_LOCALE = 'CART_UPDATE_VARIANTE_LOCALE';